module.exports = __webpack_public_path__ + "img/icon_home_kaiting.5c46d75f.png";